import { FocusTrap } from "@aleksundshantu.com/aunds-utils-react/accessibility";
import { useModal } from "../ModalRoot/ModalRoot";
import styles from "./ModalContent.module.scss";
import { useAppContext } from "@/context/AppContext";

interface ModalContentProps {
  children: React.ReactNode;
  extraClassName?: string;
  hasChildrenModal?: boolean;
  enableTouchSwipe?: boolean;
}

const ModalContent = ({
  children,
  hasChildrenModal = false,
  extraClassName = "",
  enableTouchSwipe = false,
}: ModalContentProps) => {
  const { open, setOpen } = useModal();
  const { setFormModalType } = useAppContext();

  return (
    open && (
      <FocusTrap autoFocus>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <div
          role="dialog"
          aria-modal={open}
          className={`${styles["modal-content"]} ${extraClassName ? extraClassName : ""} ${enableTouchSwipe ? styles["enable-touch-swipe"] : ""}`}
          onKeyDown={(e) => {
            if (e.key === "Escape" && !hasChildrenModal) {
              setOpen(false);
              setFormModalType("text");
            }
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setOpen(false);
              setFormModalType("text");
            }
          }}
        >
          {children}
        </div>
      </FocusTrap>
    )
  );
};

export default ModalContent;
